'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var fetchSpotReportViews = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(spotIds, serviceConfig) {
    var url, response, body;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = serviceConfig.serviceUrl + '/kbyg/spots/batch';
            _context.next = 3;
            return fetch(url, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: (0, _stringify2.default)({ spotIds: spotIds })
            });

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();

          case 6:
            body = _context.sent;

            if (!(response.status === 200)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return', body);

          case 9:
            throw body;

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function fetchSpotReportViews(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = fetchSpotReportViews;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/fetchSpotReportViews.js
// module id = 289
// module chunks = 11